var $ = require('../../modules/$');
module.exports = function create(P, D){
  return $.create(P, D);
};


//////////////////
// WEBPACK FOOTER
// ./~/redux-api-middleware/~/core-js/library/fn/object/create.js
// module id = 965
// module chunks = 0